import React, { useEffect, useState } from "react";
import axios from '../../../services/axios';
import { DownloadOutlined, EyeOutlined, SendOutlined, CheckCircleOutlined, CloseCircleOutlined, CheckCircleTwoTone, HourglassTwoTone, UploadOutlined } from "@ant-design/icons";
import { Form, Select, DatePicker, Pagination, Table, Button, Modal, Card, message, Input, Upload, Radio } from 'antd';
import dayjs from 'dayjs'; 
import moment from "moment";
import { DOCUMENT_CONTROLLER, QUANTITY_SURVEYOR, CONSULTANT_DOCUMENT_CONTROLLER } from "../../../constants/role";
import { useNavigate } from 'react-router-dom';
import { CONSULTANT, CONTRACTOR, EMPLOYER } from "../../../constants/userType";

const { Option } = Select; 

const ViewPaymentReceipt = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [documents, setDocuments] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [timeline, setTimeline] = useState(dayjs().add(1, 'day').format("YYYY-MM-DD"));
  const [selectedFile, setSelectedFile] = useState(null);
  const [pendingCount, setPendingCount] = useState(0);
  const [approvedCount, setApprovedCount] = useState(0);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const [originalDocUrl, setOriginalDocUrl] = useState(null);
  const [isComparisonView, setIsComparisonView] = useState(false);
  const [activeStatus, setActiveStatus] = useState("Pending");
  const [rejectReason, setRejectReason] = useState("");
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [isRejectLoading, setIsRejectLoading] = useState(false); 
  const user = localStorage.getItem('user');
  const role = JSON.parse(localStorage.getItem('role'))[0];
  const projectName = JSON.parse(localStorage.getItem('Project'))        
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const [approvalType, setApprovalType] = useState("approve");
  const [approvalComment, setApprovalComment] = useState("");
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const userType = localStorage.getItem('userType');
  const [selectedRole, setSelectedRole] = useState(null);

  const handleDownload = (file) => {
    if (!file) {
      console.error("File is undefined or null");
      return;
    }
    
    fetch(file)
      .then(response => response.blob()) 
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const temp = file[file.length - 1];
        link.download = temp.split("/").pop(); 
        link.click();
        window.URL.revokeObjectURL(url); 
      })
      .catch(error => console.error("Error downloading file:", error));
  };
  
  const handlePreview = (file, originalDoc = null, isComparison = false) => {
    if (file) {
      const fileToPreview = Array.isArray(file) ? file[file.length - 1] : file;
      setFileUrl(fileToPreview);


      if(isComparison && originalDoc){
        setOriginalDocUrl(originalDoc);
        setIsComparisonView(true);
      } else {
        setOriginalDocUrl(null);
        setIsComparisonView(false);
      }
      setIsModalVisible(true); 
    } else {
      console.error("File URL is invalid or missing.");
    }
  };

  const handleApproveWithComment = () => {
      if (!selectedRecord) return;
      if (approvalType === "approveWithComment" && !approvalComment.trim()) {
        message.error("Please enter a comment before submitting.");
        return;
      }

      approveByRole(selectedRecord.code, approvalComment);

      setSelectedRecord(prev => ({ ...prev }));

      setIsApproveModalOpen(false);
      setApprovalComment("");
      fetchDocuments(); 
      fetchDocumentCount();
  };

  const handleOpenApproveModal = (record) => {
    setSelectedRecord(record);  
    setIsApproveModalOpen(true);
  };  

  const handleRejectedDocPreview = (record) => {
    if (record.status === "Rejected" && record.rejectionReasons && 
        record.rejectionReasons[0]?.rejectedDocumentUrl && record.documentUrl) {
      handlePreview(
        record.rejectionReasons[0].rejectedDocumentUrl, 
        record.documentUrl, 
        true
      );
    }
  };

  const handleReupload = (record) => {
    navigate('/home/payment-receipt',{
      state: { 
        prefillData: {
            paymentReceiptRef: record.paymentReceiptRef,
            ipcRef: record.ipcRef,
            ipcAmount: record.ipcAmount,
            paymentAmount: record.paymentAmount,
            originalDocumentCode: record.code,
            paymentReceiptDate: record.paymentReceiptDate,
          }
        }
       });
    };

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsComparisonView(false);
    setOriginalDocUrl(null); 
  };
  
 
  const handleOpenModal = (file) => {
    setSelectedFile(file);
    setIsModalOpen(true);
    if(!role.includes(DOCUMENT_CONTROLLER) && userType === CONTRACTOR){
      sendToUser(file.documentReference);
    } else if(role.includes(CONSULTANT_DOCUMENT_CONTROLLER)){
      getSendToRoles();
    }
  };

  const handleUploadModalOpen = (record) => {
    setSelectedFile(record);
    setIsUploadModalOpen(true);
  }

  const handleModalClose = () => {
    setIsModalOpen(false);
    form.resetFields();
    setSelectedRole(null); 
    setFileList([])
    setTimeline("");
  };

  const handleUploadModalClose = () => {
    setRejectReason('');
    setFileList([]);
    fetchDocuments();
    fetchDocumentCount();
    setSelectedFile(null);
    setIsRejectLoading(false);
    setIsUploadModalOpen(false);
  }

  const sendDocument = async (values) => {
    values.code = selectedFile.code;
    values.user = user;

    if(!values.timeline){
      values.timeline = timeline
    }

    try {
      setLoading(true);
      let endpoint = '';

      if (role.includes(CONSULTANT_DOCUMENT_CONTROLLER)) {
        if(DOCUMENT_CONTROLLER.includes(values.sendTo)){
          endpoint = 'send-back-to-dc-payment-receipt';
        } else {
          endpoint = 'send-to-consultant-users-payment-receipt';
        }
      } else {
        endpoint = 'send-to-next-user-payment-receipt';
      }

      if(role.includes(DOCUMENT_CONTROLLER) && userType === CONTRACTOR){
        if(values.sendTo === QUANTITY_SURVEYOR){
          await axios.post('send-to-quantity-surveyor-payment-receipt', values);
        } else {
          let formData = new FormData();

          if (fileList.length === 0) {
            message.warning("Please upload a file.");
            return;
          }

          if (fileList.length > 0) {
            formData.append('file', fileList[0].originFileObj);
          }
          const data = { ...values };
          formData.append('data', JSON.stringify(data));

          await axios.post('send-to-dc-consultant-payment-receipt', formData,{
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            timeout: 60000
          })
        }
      } else {
        await axios.post(endpoint, values);
      }
      message.success('Document sent successfully!');
      handleModalClose();
      fetchDocuments();
      fetchDocumentCount();
      setLoading(false)
    } catch (err) {
      setLoading(false)
     if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
      } else if (err.response && err.response.status === 401) {
        message.error('User not authorized');
      } else {
        message.error('Something went wrong1');
      }
    }
  };
  
  const approveByRole = async (code) => {
    let endpoint = "";
  
    if (userType === CONTRACTOR) {
      endpoint = 'approve-document-payment-receipt';
    } else {
      endpoint = 'approved-by-consultant-payment-receipt';
    } 
  
    try {
      await axios.post(endpoint, { code, comment: approvalComment, user, role });
      message.success("Approved Successfully");
      fetchDocuments(activeStatus);
      setLoading(false);
      setIsApproveModalOpen(false);
    } catch (err) {
      setLoading(false);
      console.error("error", err);
      if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
      } else if (err.response && err.response.status === 401) {
        message.error('User not authorized');
      } else {
        message.error('Something went wrong5');
      }    
      console.error("API Error:", err.response ? err.response.data : err);
    }
  };

  const fetchDocumentCount = async () => {
    try {
      const res = await axios.post('document-count-payment-receipt', { role, user, projectName });
      if (res && res.data) {
          setPendingCount(res.data.pendingCount);
        } 
      if(res && res.data) {
          setApprovedCount(res.data.approvedCount);
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
      } else if (err.response && err.response.status === 401) {
        message.error('User not authorized');
      } else {
        message.error('Something went wrong2');
      }    
    }
  };
    
  const fetchDocuments = async () => {
    try {
      setLoading(true);
      const res = await axios.post('get-payment-receipt-documents', {role, user, projectName})
      if (res && res.data && res.data.documents && res.data.documents) {
        setDocuments(res.data.documents);
      }
      setLoading(false);
    } catch (err) {
        if (err.response && err.response.data && err.response.data.msg) {
        message.warning(err.response.data.msg);
      } else if (err.response && err.response.data && err.response.data.userName) {
        message.warning(err.response.data.userName[0]);
      } else if (err.response && err.response.status === 401) {
        message.error('User not authorized');
      } else {
        message.error('Something went wrong3');
      }
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, []);

  //  const getRoles = async () => {
  //     try {
  //       const res = await axios.get('get-all-roles');
  //       if (res && res.data && res.data.roles && res.data.roles) {
  //         setRoles(res.data.roles);
  //       }
  //     } catch (err) {
  //       if (err.response && err.response.data && err.response.data.msg) {
  //         message.warning(err.response.data.msg);
  //       } else if (err.response && err.response.data && err.response.data.userName) {
  //         message.warning(err.response.data.userName[0]);
  //       } else if (err.response && err.response.status === 401) {
  //         message.error('User not authorised');
  //       } else {
  //         message.error('Something went wrong4');
  //       }
  //     }
  //   }
  
    useEffect(() => {
      fetchDocumentCount();
      // getRoles();
    }, []);

    const getSendToRoles = async () => {
      try {
        const res = await axios.post('get-send-to-roles', { user });
        if (res && res.data && res.data.userRoles) {
          setRoles(res.data.userRoles);
        }
      } catch (err) {
        if (err.response && err.response.data && err.response.data.msg) {
          message.warning(err.response.data.msg);
        } else if (err.response && err.response.data && err.response.data.userName) {
          message.warning(err.response.data.userName[0]);
        } else if (err.response && err.response.status === 401) {
          message.error('User not authorised');
        } else {
          message.error('Something went wrong');
        }
      }
    }
  
    const handleRejectSubmit = async () => {
      if (!rejectReason.trim()) {
        message.error("Please provide a reason for rejection.");
        return;
      }
      setIsRejectLoading(true)
      try {
        if(userType === CONSULTANT){
          await axios.post('reject-by-consultant-payment-receipt', {code: selectedFile.code, role, user, rejectReason:rejectReason});
        } else {
          await axios.post('reject-document-payment-receipt', {code: selectedFile.code, role, user, rejectReason:rejectReason});
        }
        message.success( "Rejection submitted successfully!");
        handleUploadModalClose();
      } catch (err) {
         if (err.response && err.response.data && err.response.data.msg) {
          message.warning(err.response.data.msg);
        } else if (err.response && err.response.data && err.response.data.userName) {
          message.warning(err.response.data.userName[0]);
        } else if (err.response && err.response.status === 401) {
          message.error('User not authorized');
        } else {
          message.error('Something went wrong6');
        }
      } finally {
        setIsRejectLoading(false);
      }
    };
  
    const getUniqueFilters = (key) => {
      return [...new Set(documents.map((doc) => doc[key]))]
        .filter(Boolean)
        .map((value) => ({ text: value, value }));
    };
    
    const sendToUser = async (documentReference) => {
      try {
        const res = await axios.post('get-send-to-user-payment-receipt', { user, documentReference });
        if (res && res.data && res.data.nextRole) {
          form.setFieldValue('sendTo', res.data.nextRole);
          setSelectedRole(res.data.nextRole)        }
      } catch (err) {
        if (err.response && err.response.data && err.response.data.msg) {
          message.warning(err.response.data.msg);
        } else if (err.response && err.response.data && err.response.data.userName) {
          message.warning(err.response.data.userName[0]);
        } else if (err.response && err.response.status === 401) {
          message.error('User not authorised');
        } else {
          message.error('Something went wrong9');
        }
      }
    }
     
  const columns = [
    {
      title: "Payment Receipt Ref.",
      dataIndex: "paymentReceiptRef",
      key: "paymentReceiptRef",
      width: 200,
      ellipsis: true,
      filters: getUniqueFilters('paymentReceiptRef'),
      onFilter: (value, record) => record.paymentReceiptRef?.startsWith(value),
      filterSearch: true,
      render: (text, record) => 
        text ? (
        <a
          onClick={() => navigate(`/home/view-payment-receipt/ipcRef/:receipt`, { state: record })}
          className="text-blue-500 hover:underline cursor-pointer"
        >
          {text}
        </a>
        ) : 
        (
          "NA"
        ),
    },
    {
      title: "IPC Ref.",
      dataIndex: "ipcRef",
      key: "ipcRef",
      width: 150,
      filters: getUniqueFilters('ipcRef'),
      onFilter: (value, record) => record.ipcRef?.startsWith(value),
      filterSearch: true,
      ellipsis: true,
    },
    {
      title: "IPC Amount",
      dataIndex: "ipcAmount",
      key: "ipcAmount",
      width: 130,
      render: (text, record) => text ? text : 'NA'
    },
    {
      title: "Payment Amount",
      dataIndex: "paymentAmount",
      key: "paymentAmount",
      width: 130,
      render: (text, record) => text ? text : 'NA'
    },
    {
      title: "Payment Receipt Date",
      dataIndex: "paymentReceiptDate",
      key: "paymentReceiptDate",
      render: (date) => date ? moment(date).format("YYYY-MM-DD") : 'NA',
      width: 130,
    },
    userType !== 'Consultant' && {
      title: 'Version',
      dataIndex: 'version',
      key: 'version',
      width: 130,
      render: (text, record) => text ? text : 'NA'
    },  
    userType === 'Consultant' && {
      title: 'Revision',
      dataIndex: 'revision',
      key: 'revision',
      width: 130,
      render: (text, record) => text ? text : 'NA'
    },   
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 120,
      ellipsis: true,
      render: (status) => {
        return <span className={status === "Accepted" ? "text-green-600" : status === "Rejected" ? "text-red-600" : "text-gray-800"}>{status}</span>;
      }
    },
    {
      title: 'WorkFlow Stage',
      dataIndex: 'stage',
      key: 'stage',
      width: 170,
      render: (text, record) => text ? text : 'NA'
    },
    (!role.includes(QUANTITY_SURVEYOR) && !role.includes(DOCUMENT_CONTROLLER)) && {
      title: "Timeline",
      dataIndex: "timelineDetails",
      key: "timelineDetails",
      width: 120,
      render: (timelineDetails) => {
        if (!timelineDetails) return "NA";
        if(timelineDetails){
          return timelineDetails?.[role[0]]?.date ? moment(timelineDetails?.[role].date).format('DD/MM/YYYY') : 'NA'; 
        } else {
          return 'NA'
        }  
      }
    },
    role.includes(QUANTITY_SURVEYOR) && {
      title: 'Rejected Documents',
      key: 'rejectDocument',
      width: 250,
      render: (text, record) => (
        record.status === "Rejected" ? (
          <div className="flex space-x-2">
          {/* <Button 
            type="primary" 
            onClick={() => handleRejectedDocPreview(record)}
          >
            Compare
          </Button> */}
          <button
            className="reupload-btn"
            onClick={() => handleReupload(record)}
          >
            RE-UPLOAD
           </button>  
          </div>  
        ) : (
          <span>-</span>
        )
      )
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 200,
      render: (text, record) => (
        <div>
        {/* Download Button */}
        <Button
            icon={<DownloadOutlined />}
            onClick={() => handleDownload(userType === 'Consultant' ? record.docWithTransmittal : record.documentUrl)}
            style={{ backgroundColor: 'white', color: 'blue', marginRight: '10px' }}
          />
 
        {/* Preview Button */}
        <Button
            icon={<EyeOutlined />}
            onClick={() => handlePreview(userType === 'Consultant' ? record.docWithTransmittal : record.documentUrl)}
            style={{ backgroundColor: 'white', color: 'black', marginRight: '10px' }}
          />
 
        {/* Send Button */}
        {record.status !== "Rejected" && !record.status.includes('Approved by Consultant') &&
          (
            (role.includes('Quantity Surveyor') && !record.sentDetails?.[role]?.sent) || 
            (role.includes('Document') && record.timelineDetails?.[role]?.date && !record.sentDetails?.[role]?.sent) ||
            (!role.includes(DOCUMENT_CONTROLLER) && record.approvedDetails?.[role]?.approved &&  !record?.sentDetails?.[role]?.sent)
          ) && 
            (
            <Button
              icon={<SendOutlined />}
              onClick={() => handleOpenModal(record)}
              style={{ backgroundColor: 'white', color: 'green', marginRight: '10px' }}
            />
        )}
 
        {/* Pending Status Actions */}
        {!record.status.includes('Rejected') && (
          <>
            {( !role.includes('Quantity Surveyor') && !role.includes('Document') && record.timelineDetails?.[role]?.date && !record.approvedDetails?.[role]?.approved ) && (
              <>
                {/* Approve Button */}
                <Button  
                  icon={<CheckCircleOutlined />}
                  onClick={() => handleOpenApproveModal(record)}  
                  style={{ backgroundColor: 'white', color: 'green', marginRight: '10px' }}
                >
                  
                </Button>

                {/* Reject Button */}
                <Button
                  icon={<CloseCircleOutlined />}
                  onClick={() => handleUploadModalOpen(record)}
                  style={{ backgroundColor: 'white', color: 'red', marginRight: '10px' }}
                />
              </>
            )}
          </>
        )}
      </div>
      ),
    },                
  ];

  return (
    <div className="relative flex-1 p-5 overflow-y-auto min-h-screen ml-6 mr-1">
      <div className="max-w-7xl mx-auto">
        <div className="flex space-x-7 mb-6">
          {!(role.includes(QUANTITY_SURVEYOR) || role.includes(DOCUMENT_CONTROLLER)) && (
            <>
              <Card
                className={`w-56 transition-transform transform hover:scale-105 
                            bg-yellow-50 shadow-xl border-yellow-300 rounded-xl border`}
              >
                <div className="flex items-center space-x-3">
                  <HourglassTwoTone twoToneColor="#FFAA33" style={{ fontSize: "24px" }} />
                  <h2 className="text-lg font-semibold text-yellow-800">Pending</h2>
                </div>
                <p className="text-3xl font-bold text-yellow-800 mt-2">{pendingCount}</p>
              </Card>

              <Card
                className={`w-56 transition-transform transform hover:scale-105 
                            bg-teal-50 shadow-xl border-teal-300 rounded-xl border`}
              >
                <div className="flex items-center space-x-3">
                  <CheckCircleTwoTone twoToneColor="#30C4A0" style={{ fontSize: "24px" }} />
                  <h2 className="text-lg font-semibold text-teal-800">Approved</h2>
                </div>
                <p className="text-3xl font-bold text-teal-800 mt-2">{approvedCount}</p>
              </Card>
            </>
          )}
        </div>

        {/* <Card className="shadow-md rounded-lg p-6 w-full max-w-9xl mx-auto"> */}
          <div className="overflow-x-auto">
            <Table 
              dataSource={documents} 
              columns={columns.filter((e)=> e !== false)} 
              rowKey="title"
              pagination={true}
              loading={loading}            />         
          </div>

      <Modal
        title={<div className="text-center">📄 Send Document</div>}
        open={isModalOpen}
        onCancel={handleModalClose}
        footer={null}
        style={{ padding: '20px', maxHeight: '400px', overflowY: 'auto' }}
      >
        <Form form={form} onFinish={sendDocument}
        initialValues={{
          timeline: dayjs().add(1, 'day'), // Set default to tomorrow
        }}>
          {/* Select Roles Form Item */}
          <Form.Item
            label="Send To:"
            name="sendTo"
            rules={[{ required: true, message: 'Please select at least one role' }]}
            style={{ marginBottom: '16px' }}
          >
            {role.includes(DOCUMENT_CONTROLLER) && userType === CONTRACTOR ? (
              <Select className="w-full" 
              onChange={(value) => setSelectedRole(value)}>
                  <>
                    <Option key={CONSULTANT_DOCUMENT_CONTROLLER} value={CONSULTANT_DOCUMENT_CONTROLLER}>
                      {CONSULTANT_DOCUMENT_CONTROLLER}
                    </Option>
                    <Option key={QUANTITY_SURVEYOR} value={QUANTITY_SURVEYOR}>
                      {QUANTITY_SURVEYOR}
                    </Option>
                  </>
                </Select>
              ) : role.includes(CONSULTANT_DOCUMENT_CONTROLLER) ? (
                <Select className="w-full"  mode="multiple">
                  {roles.map((e)=>(
                    <Option key={e.role} value={e.role}>
                    {e.role}
                  </Option>
                  ))}
                </Select>
              ) : (
                <Input readOnly />
              )}
          </Form.Item>

          {/* Timeline Form Item */}
          {!(role.includes(DOCUMENT_CONTROLLER)  || selectedRole?.includes('Document')) && (<Form.Item
            label="Set Date"
            name="timeline"
            rules={[{ required: true, message: 'Please set a timeline' }]}
            style={{ marginBottom: '16px' }} 
          >
            <DatePicker
              format="YYYY-MM-DD"
              onChange={(date) => setTimeline(date ? date.format("YYYY-MM-DD") : "")} 
              style={{ width: '100%' }} 
              disabledDate={(current) => current && current < dayjs().startOf('day')} 
            />
          </Form.Item>)}
            {(role.includes(DOCUMENT_CONTROLLER) && selectedRole === CONSULTANT_DOCUMENT_CONTROLLER) && (<Form.Item label="Upload Transmittal Document" name="file"
              rules={[{ required: true, message: 'Please upload a transmittal document'}]} >
                <Upload 
                  fileList={fileList}
                  maxCount={1}
                  beforeUpload={() => false}
                  onChange={({ fileList }) => setFileList(fileList)}
                  className="w-full" 
                >
                  <Button 
                  icon={<UploadOutlined />}
                  className="w-full h-12 flex items-center justify-center text-blue-500 border border-blue-500 hover:bg-blue-500 hover:text-white"
                >
                  Select File
                  </Button>
                </Upload>
              </Form.Item>)}
          
          {/* Submit Button */}
          <div className="flex justify-center">
            <Button 
              type="primary" 
              htmlType="submit" 
              className="w-1/4 mt-4" 
              style={{ backgroundColor: 'green', color: 'white' }} 
              loading={loading}
            >
              Send
            </Button>
          </div>
        </Form>
      </Modal>

      <Modal
        title="Approval Options"
        visible={isApproveModalOpen}
        onCancel={() => setIsApproveModalOpen(false)}
        footer={null}
        
      >
        <Radio.Group 
          onChange={(e) => setApprovalType(e.target.value)} 
          value={approvalType}
        >
          <Radio value="approve">Approve</Radio>
          <Radio value="approveWithComment">Approve with Comment</Radio>
        </Radio.Group>

        {approvalType === "approveWithComment" && (
          <div style={{ marginTop: "10px" }}>
            <Input.TextArea
              rows={4}
              placeholder="Enter your comment"
              value={approvalComment}
              onChange={(e) => {
                const comment = e.target.value;
                setApprovalComment(comment); 
              }}
            />

            
          </div>
        )}
        <div className="flex ">
        <Button 
              type="primary" 
              onClick={handleApproveWithComment}
              style={{ marginTop: "10px" }}
            >
              Submit Approval
            </Button>
            </div>
      </Modal>

                {/* Modal for Preview */}
                <Modal
            title={isComparisonView ? "Document Comparison" : "File Preview"}
            open={isModalVisible}
            onCancel={handleCancel}
            footer={null}
            width={isComparisonView ? 1000 : 800}
            // styles={{
            //   backdropFilter: 'blur(1px)',
            //   backgroundColor: 'rgba(0, 0, 0, 0.2)' 
            // }}
            style={{ padding: '0' }}
          >


            {isComparisonView ? (
              <div className="flex flex-col md:flex-row">
               <div className="w-full md:w-1/2 border-r border-gray-300">
                <div className="bg-gray-100 p-2 text-center font-semibold border-b">Original Document</div>
            <iframe
              src={originalDocUrl}
              width="100%"
              height="500px"
              style={{ border: 'none' }}
              title="Original Document"
            />
            </div>
            <div className="w-full md:w-1/2">
             <div className="bg-gray-100 p-2 text-center font-semibold border-b">Rejected Document</div>
            <iframe
            src={fileUrl}
            width="100%"
            height="500px"
            style={{ border: 'none' }}
            title="Rejected Document"
            />
            </div>
            </div>
            ) : (
              <iframe
              src={fileUrl}
              width="100%"
              height="500px"
              style={{ border: 'none' }}
              title="Document Preview"
              />
            )}
          </Modal>

          <Modal
            title="Reject Document"
            visible={isUploadModalOpen}
            onCancel={handleUploadModalClose}
            footer={null}
            destroyOnClose={true}
          >
            <Form layout="vertical" preserve={false}>
              {/* Reason Input */}
              <Form.Item label="Rejection Reason" name="rejectionreason" rules={[{ required: true, message: 'Please provide a reason for rejection' }]}>
                <Input.TextArea
                  value={rejectReason}
                  onChange={(e) => setRejectReason(e.target.value)}
                  placeholder="Enter rejection reason"
                  rows={3}
                />
              </Form.Item>

              {/* Submit Button */}
              <div className="flex justify-center">
                <Button 
                  type="primary"  
                  onClick={handleRejectSubmit}
                  className="w-1/4 mt-4" 
                  style={{ backgroundColor: 'red', color: 'white' }}
                >
                  {isRejectLoading ? 'Uploading...' : 'Submit Rejection'}
                </Button>
              </div>
            </Form>
          </Modal>          
        {/* </Card> */}
    </div>
  </div>
  );
};

export default ViewPaymentReceipt;